document.addEventListener("DOMContentLoaded", function () {
    const allProductCards = document.querySelectorAll(".wrap-product");
    allProductCards.forEach(function (card) {
        const colorOptions = card.querySelectorAll(".product-color-option");
        const hoverImages = card.querySelectorAll(".product-hover-img");
        const priceElement = card.querySelector(".product-desc__price");

        if (!colorOptions.length || !hoverImages.length || !priceElement) {
            return;
        }

        const originalPriceHTML = priceElement.innerHTML;
        const firstImage = hoverImages[0];

        // Function to handle switching
        function switchVariation(option) {
            const variationId = option.getAttribute("data-variation-id");
            // const newPrice = option.getAttribute("data-price-html");

            hoverImages.forEach(function (img) {
                if (img.getAttribute("data-variation-id") === variationId) {
                    img.classList.remove("d-none");
                } else {
                    img.classList.add("d-none");
                }
            });
        }

        colorOptions.forEach(function (option) {
            // Desktop hover
            option.addEventListener("mouseenter", function () {
                switchVariation(option);
            });

            // Mobile click
            option.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                switchVariation(option);
            });
        });

        const colorOptionsContainer = card.querySelector(".product-color-options");
        if (colorOptionsContainer) {
            // Only reset on desktop hover out
            colorOptionsContainer.addEventListener("mouseleave", function () {
                hoverImages.forEach(function (img) {
                    img.classList.add("d-none");
                });
                if (firstImage) {
                    firstImage.classList.remove("d-none");
                }
                // priceElement.innerHTML = originalPriceHTML;
            });
        }
    });
});
